import { Link } from '@inertiajs/react'
import { Badge } from '@/components/ui/badge'
import {
  TASK_PRIORITY_LABELS,
  TASK_STATUS_LABELS,
  type TaskRow,
} from '@/types/work'

interface SubtaskTreeProps {
  subtasks: TaskRow[]
  // When provided (sheet/embedded mode), clicking a subtask invokes
  // the callback instead of doing an Inertia navigation. The standalone
  // page mounts SubtaskTree without this prop and keeps the <Link>
  // navigation behavior.
  onSelectTask?: (id: number) => void
}

// v1: flat one-level list of immediate children. The plan describes a
// recursive disclosure-caret tree with a 5-row cap and "Voir N de plus"
// overflow link; that's deferred (TODO §Unit 12). For now subtasks
// linkable rows show inline.
export function SubtaskTree({ subtasks, onSelectTask }: SubtaskTreeProps) {
  if (subtasks.length === 0) {
    return <p className="text-sm text-muted-foreground">Aucune sous-tâche</p>
  }

  return (
    <ul className="space-y-2">
      {subtasks.map((task) => (
        <li
          key={task.id}
          className="flex items-center justify-between rounded-md border bg-card px-3 py-2"
        >
          <div className="min-w-0 flex-1">
            {onSelectTask ? (
              <button
                type="button"
                onClick={() => onSelectTask(task.id)}
                className="font-medium text-left hover:underline"
              >
                {task.title}
              </button>
            ) : (
              <Link
                href={`/work/tasks/${task.id}`}
                className="font-medium hover:underline"
              >
                {task.title}
              </Link>
            )}
            <div className="mt-0.5 flex items-center gap-2 text-xs text-muted-foreground">
              <span>{TASK_STATUS_LABELS[task.status]}</span>
              {task.assignee_name && <span>· {task.assignee_name}</span>}
              {task.due_at && (
                <span>· échéance {new Date(task.due_at).toLocaleDateString('fr-FR')}</span>
              )}
            </div>
          </div>
          <Badge variant="outline">{TASK_PRIORITY_LABELS[task.priority]}</Badge>
        </li>
      ))}
    </ul>
  )
}
